import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import axios from "axios";
import { BsFiletypeDocx } from "react-icons/bs";

const Preparazione_documento_convenzione = (props) => {

    const [value, setValue] = useState();

    function preparazione_documenti(tipo_documento) {
        console.log('Preparazione documenti convenzione');
        const nuova_ditta = {
            id: props.ditta._id,
            ragione_sociale: props.ditta.ragione_sociale,
            partita_iva: props.ditta.partita_iva,
            ditta_indirizzo_citta: props.ditta.ditta_indirizzo_citta,
            ditta_indirizzo_via: props.ditta.ditta_indirizzo_via,
            ditta_indirizzo_civico: props.ditta.ditta_indirizzo_civico,
            codice_fiscale: props.ditta.codice_fiscale,
            luogo_nascita: props.ditta.luogo_nascita,
            data_nascita: props.ditta.data_nascita,
            cognome: props.ditta.cognome,
            nome: props.ditta.nome,
            tipo_documento: tipo_documento 
        }
        console.log(nuova_ditta);
        axios.post('/transfer_s3/preparazione_documento_file_word', nuova_ditta)
        .then((res) => {
            console.log('RIENTRATO')

            console.log(res.data)
            if (tipo_documento === 'convenzione') download_docx('convenzione_docx')
            if (tipo_documento === 'sicurezza') download_docx('sicurezza_docx')

            //                SET_variab_aggiorna(JSON.stringify(res.data))
        }).catch((error) => {
            console.log(error)
        });
    }



    const download_docx = (indirizzo) => {
        const cognome = props.ditta.ragione_sociale
        const nome = props.ditta.partita_iva

        //        {/* idroslab  */} scaricamento di un file restituito dal server

        axios.get('/transfer_s3/progetto_docx_ottieni_url/' + indirizzo + '/' + cognome + '/' + nome )
            .then((res) => {
                console.log('xxxxxxxxxxxxxxxxx url ottenuti dal router')
                console.log(res.data)
                const newWindow = window.open(res.data, '_blank', 'noopener,noreferrer')

                if (newWindow) newWindow.opener = null
               
//                return res.data
            }).catch((error) => {
                console.log('ottieni_url url errore')
                console.log(error)
            });
    };



    return (
        <div>
          
            <div class="dropdown-divider"></div>


            
            <Dropdown.Item onClick={() => preparazione_documenti('convenzione')}> <div class="d-flex justify-content-between"> Compila convenzione <BsFiletypeDocx /> </div> </Dropdown.Item>
            <Dropdown.Item onClick={() => preparazione_documenti('sicurezza')}> <div class="d-flex justify-content-between"> Compila sicurezza <BsFiletypeDocx /> </div>  </Dropdown.Item>


        </div>
    )
}
export default Preparazione_documento_convenzione;